const AppConstants = {
    TimezoneOffset: '-04:00',
    microsoftClientId: "264d0ea6-fba2-4d90-aa74-bceeee062c44",
    microsoftTenantId: "3bc90aa9-088f-4447-9eb2-ff13839e19dd",
    microsoftAuthority: "https://login.microsoftonline.com/3bc90aa9-088f-4447-9eb2-ff13839e19dd",
    
    // Local Redirect URI
    // microsoftRedirectURI: "http://localhost:3000/"
    // QA Redirect URI
    // microsoftRedirectURI: "https://vtestadmin-qa.vthinkglobal.com/"

    // Production Redirect URI
    microsoftRedirectURI: "https://vtest.vthinkdeveloper.com/"
};

export default AppConstants;
   